import { render, staticRenderFns } from "./WeeklyReportViewPurchasesOrders.vue?vue&type=template&id=da1727e6"
import script from "./WeeklyReportViewPurchasesOrders.vue?vue&type=script&lang=js"
export * from "./WeeklyReportViewPurchasesOrders.vue?vue&type=script&lang=js"
import style0 from "./WeeklyReportViewPurchasesOrders.vue?vue&type=style&index=0&id=da1727e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports